const tutorList = [
  "Language Arts",
  "Mathematics",
  "Science",
  "Health",
  "Handwriting",
  "Physical Education",
  "Art",
  "Spanish or other foreign language",
  "Speech Therapy",
  "Occupational Therapy",
];

const musicList = [
  "Banjo",
  "Bassoon",
  "Cello",
  "Clarinet",
  "Cornet",
  "French horn",
  "Flute",
  "Guitar",
  "Harpsichord",
  "Mandolin",
  "Oboe",
  "Percussion",
  "Piano",
  "Piccolo",
  "Saxophone",
  "Trumpet",
  "Trombone",
  "Tuba",
  "Ukulele",
  "Violin",
  "Viola",
  "Xylophone",
];

const playList = ["Reading Out Loud", "Sing A Longs", "Arts & Crafts"];

const careerList = [
  "Resume Building",
  "Resume Review",
  "Life Coaching",
  "Interview Preparation",
];

export default function careCategoryOptions(withDefault = false, listType) {
  let opts = [];
  if (withDefault) opts.push({ value: "", label: "Any Category" });
  let list = [];
  switch (listType) {
    case "Tutor":
      list = tutorList;
      break;
    case "Music":
      list = musicList;
      break;
    case "EducationalPlay":
      list = playList;
      break;
    case "CareerServices":
      list = careerList;
      break;
    default:
      list = [...tutorList, ...musicList, ...playList, ...careerList];
  }
  list.map((l) => {
    opts.push({ label: l, value: l });
  });
  return opts;
}

export const careCategorySelectOptions = (withDefault = true) => {
  const base = [{ label: "All Types", value: "" }];
  // const types = [
  //   { label: "Tutor", value: "Tutor" },
  //   { label: "Music", value: "Music" },
  //   { label: "Educational Play", value: "EducationalPlay" },
  //   { label: "Career Services", value: "CareerServices" },
  // ];
  const types = [];
  Object.values(careTypeList).forEach((careType) =>
    types.push({ label: careType.label, value: careType.value })
  );
  return withDefault ? [...base, ...types] : types;
};

export const careTypeList = {
  tutor: {
    label: "Tutor",
    value: "Tutor",
    description: "One-on-one educational sessions",
    caregiverLabel: "Tutors",
    extra:
      "Whether your child just needs a little oversight with homework or wants to learn a new language, our experienced tutors are here to help.",
  },
  music: {
    label: "Music",
    value: "Music",
    description: "Music lessons and education",
    caregiverLabel: "Music Instructors",
    extra:
      "Live music lessons with a professional instructor offering help with a new or existing instrument. ",
  },
  educationalplay: {
    label: "Virtual Babysitting",
    value: "EducationalPlay",
    description: "Reading aloud, arts & crafts projects and more",
    caregiverLabel: "Virtual Babysitters",
    extra:
      "We keep your child(ren) engaged and entertained with age appropriate activities run by our virtual caregivers.",
  },
  careerservices: {
    label: "Career Services",
    value: "CareerServices",
    description: "Professional career services",
    extra:
      "Connect with a professional for feedback on your resume, preparing for an interview, or life coaching.",
    caregiverLabel: "Career Service Providers",
  },
};
